import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Styles from '../../../GeneralUI/Styles';
import { Paper, InputLabel, Grid } from '@material-ui/core';
import { search } from '../../../../Actions/General';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { TextField, Button } from '@material-ui/core';
import { SnackbarProvider, withSnackbar } from 'notistack';
import { errorSetter } from '../../../../Libs';
import AutoComplete from '../../../GeneralUI/AutoComplete';
import DataGridVisor from '../../../GeneralUI/DataGridVisor';
import to from 'await-to-js';
import PSelect from '../../../GeneralUI/PSelect';
import _ from 'lodash';
import CustomizedExpansionPanel from '../../../GeneralUI/PExpansionpanels'


const VISOR_FIELDS = [{ 
  name: 'Codigo',
  alias: 'Codigo',
   actions: [
    {
      title: 'Consultar Encuesta',
      type: 'query', 
      url:'/encuesta_bodega',
      nameField: 'Codigo', 
      params:{
        clntn:'Cliente'      }
    }
  ]
},
{
  name: 'Sucursal',
  alias: 'Sucursal'
},
{
  name: 'Almacen',
  alias: 'Almacen'
},
{
  name: 'Cliente',
  alias: 'Cliente'
},
{
  name: 'clienteTelefonos',
  alias: 'Telefonos'
},
{
  name: 'clienteEmail',
  alias: 'Email'
},
{
  name: 'Estado',
  alias: 'Estado',
  colorize: true
},
{
  name: 'Fecha',
  alias: 'Fecha'
},

];
  
const VISOR_COLORS = {
PENDIENTE: '#FF3933',
DILIGENCIADA: '#3380FF'
}

class EncuestaBodegaVisor extends Component {
  constructor(props) {
    super(props);

    this.setErrors = errorSetter.setErrors.bind(this);
  }

  state = {
    page: 0,
    rowsPerPage: 10,
    data: {
      rows: [],
      count: 0
    },
    filters: {
      sucursalCodigo: null,
      almacenCodigo: null,
      clienteCodigo: null,
      encbodEstado: null,
      fechaInicial: null,
      fechaFinal: null,
    },
    operatorCustom: [],
    responseForm: { Message: '', typeMessage: '' },
    formErrors: {
    }
  };

  componentDidMount() {
    this.props.toggleFavorites();
  }

  componentWillUnmount() {
    this.props.toogleFavoritesShow();
  }

  search = async (page, rowsPerPage) => {
    if (page !== undefined) {
      await to(new Promise((resolve) => {
        this.setState({
          page,
          rowsPerPage
        }, resolve)
      }));
    }

    this.state.operatorCustom = [];
    let filters = {};



    if (this.state.filters.clienteCodigo !== null && this.state.filters.clienteCodigo !== '') {
      this.state.operatorCustom.push("\"clienteCodigo\" = " + this.state.filters.clienteCodigo + "");
    }


    if (this.state.filters.almacenCodigo !== null && this.state.filters.almacenCodigo !== '') {
      this.state.operatorCustom.push("\"almacenCodigo\" = " + this.state.filters.almacenCodigo + "");
    }

    if (this.state.filters.sucursalCodigo !== null && this.state.filters.sucursalCodigo !== '') {
      this.state.operatorCustom.push("\"sucursalCodigo\" = " + this.state.filters.sucursalCodigo + "");
    }

    if (this.state.filters.encbodEstado !== null && this.state.filters.encbodEstado !== '') {
      this.state.operatorCustom.push("\"Estado\" = '" + this.state.filters.encbodEstado + "'");
    }

    if (this.state.filters.fechaInicial !== null && this.state.filters.fechaInicial !== '') {
      this.state.operatorCustom.push("\"Fecha\" >= '" + this.state.filters.fechaInicial + "'");
    }

    if (this.state.filters.fechaFinal !== null && this.state.filters.fechaFinal !== '') {
      this.state.operatorCustom.push("\"Fecha\" <= '" + this.state.filters.fechaFinal + "'");
    }

    const [err, data] = await to(search({
      fields: VISOR_FIELDS.map(row => row.name),
      filters: filters,
      operatorCustom: this.state.operatorCustom,
      isView: true,
      options: {
        limit: this.state.rowsPerPage,
        skip: this.state.page * this.state.rowsPerPage,
        order: { Fecha: 'DESC' }
      }
    }, '/modules/vw_encuesta_bodega_visor/list'));

    if (err) {
      return;
    }

    this.setState({
      data: data
    });
  }

  handleChange = (event) => {
    let { filters } = this.state;
    filters[event.target.id] = event.target.value;
    this.setState({ filters });
  }

  render() {
    const { classes } = this.props;

    return (
      <Paper elevation={5} className={`${classes.mainPaper} ${classes.fullWidthPaper}`}>
        <Grid container spacing={4}>
          <Grid item xs={3} className={classes.gridForm}>
            <InputLabel className={classes.tittleLabelForm}>
              Visor Encuesta Bodega
              </InputLabel>
          </Grid>
        </Grid>

        <Grid container spacing={2}>
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <AutoComplete
                id="almacenCodigo"
                tableName='Almacen'
                fields={['almacenCodigo', 'almacenNombre']}
                primaryField='almacenCodigo'
                aliases={['ID', 'Nombre']}
                searchField='almacenNombre'
                placeHolder='Seleccionar Almacen'
                onSelect={this.handleChange}
              />
            </Grid> 
            <Grid item xs={3} className={this.props.classes.gridForm}>
              <AutoComplete
                id="sucursalCodigo"
                tableName='Sucursal'
                fields={['sucursalCodigo', 'sucursalNombre']}
                primaryField='sucursalCodigo'
                aliases={['ID', 'Nombre']}
                searchField='sucursalNombre'
                placeHolder='Seleccionar Sucursal'
                onSelect={this.handleChange}

              />
            </Grid>
            <Grid item xs={3} className={this.props.classes.gridForm}>
            <AutoComplete
              id="clienteCodigo"
              tableName='vw_cliente_autocomplete'
              isView={true}
              fields={['clienteCodigo', 'clienteRazonSocial']}
              aliases={[{ value: 'ID', size: 1 }, { value: 'Nombre', size: 11 }]}
              size='xl'
              primaryField='clienteCodigo'
              searchField='clienteRazonSocial'
              placeHolder='Seleccionar Cliente'
              onSelect={this.handleChange}

            />
          </Grid>
          </Grid>
     

        <Grid container spacing={2}>
          <Grid item className={this.props.classes.gridForm}>
            <PSelect
                  id="encbodEstado"
                  useChildren={true}
                  onChange={this.handleChange}
                  namelabel="Estado"
                >
                  <option value="PENDIENTE">PENDIENTE</option>
                  <option value="DILIGENCIADA">DILIGENCIADA</option>
                </PSelect>
            </Grid>
              <Grid item xs className={classes.gridForm}>
                  <TextField
                    id='fechaInicial'
                    type='date'
                    label='Fecha Inicial'
                    margin="normal"
                    variant="outlined"
                    onChange={this.handleChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </Grid>

                <Grid item xs className={classes.gridForm}>
                  <TextField
                    id='fechaFinal'
                    type='date'
                    label='Fecha Final'
                    margin="normal"
                    variant="outlined"
                    onChange={this.handleChange}
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                  />
                </Grid>
          </Grid>

        <Grid container spacing={10} >
          <Grid item xs={3} className={this.props.classes.gridForm}>

            <Button
              color='primary'
              variant='contained'
              onClick={(event) => this.search()}
            >
              Buscar
              </Button>

          </Grid>
        </Grid>

        <CustomizedExpansionPanel tittle="Cuadro de convenciones.">
          <Grid container spacing={2} >
            <Grid item xs className={this.props.classes.gridVisorDianAlertaAlta}>PENDIENTE</Grid>
            <Grid item xs className={this.props.classes.gridVisorDianAlertaBaja}>DILIGENCIADA</Grid>
          </Grid>
        </CustomizedExpansionPanel>

        <DataGridVisor
          search={this.search}
          data={this.state.data}
          fields={VISOR_FIELDS}
          colors={VISOR_COLORS}
          moduleUrl='encuesta_bodega'
          page={this.state.page}
          rowsPerPage={this.state.rowsPerPage}
        />

      </Paper>
    );
  }
}

EncuestaBodegaVisor.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired,
  toggleFavorites: PropTypes.func.isRequired,
  toogleFavoritesShow: PropTypes.func.isRequired
};

const MyApp = withRouter(withSnackbar(withStyles(Styles, { withTheme: true })(EncuestaBodegaVisor)));

function IntegrationNotistack(props) {
  return (
    <SnackbarProvider key={6} maxSnack={1}
      action={[
        <Button key={6} variant="text" color="primary" size="small">
          {'X'}
        </Button>
      ]}
    >
      <MyApp {...props} />
    </SnackbarProvider>
  );
}

export default IntegrationNotistack;